interface Props {
  searchValue: string
  fromDate: any
  toDate: any
  category: any
  types?: string
  filter: string | string[] | []
  years: string | string[] | []
  page: number
  limit?: number
  iress_category: number[] | null
  tags?: string[]
}

export const AnnouncementEndpoint = {
  get: ({
    searchValue = '',
    fromDate = '',
    toDate = '',
    category = '',
    filter,
    years,
    types = '',
    page,
    limit = 10,
    iress_category = [],
    tags = []
  }: Props) =>
    `announcements?q=${encodeURIComponent(searchValue)}&from_date=${fromDate}&to_date=${toDate}&category=${category}&labels=[${filter}]&types=${types}&years=[${years ?? []}]&iress_category=[${iress_category ?? ''}]${tags.length ? `&tags=${encodeURIComponent(JSON.stringify(tags))}` : ''}${searchValue ? '' : `&page=${page}&limit=${limit}`}`,
  getPriceSensitive: ({ fromDate, toDate }: { fromDate: string; toDate: string }) =>
    `announcements/price-sensitive?from_date=${fromDate}&to_date=${toDate}`
}

export interface PriceSensitiveAnnouncement {
  id: string
  title: string
  date: string
  is_price_sensitive: boolean
  engagement: {
    email: number
    question: number
    like: number
    share: number
    view: number
  }
}
